import { render, staticRenderFns } from "./MoveTo.vue?vue&type=template&id=e39e2f04"
import script from "./MoveTo.vue?vue&type=script&lang=js"
export * from "./MoveTo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports